'use strict';

const { MAX_LEVEL } = require('./constants');
const { getBossAnimal } = require('./boss-animals');

const BOSS_PATTERN_TIERS = Object.freeze([
  'aimedCarrot',
  'fanCarrot',
  'carrotRain',
  'spiralCarrot',
  'crossCarrot',
  'ringBurst',
  'homingCarrot',
  'sweepWall',
  'splitCarrot',
  'mixedCarrot'
]);

function round4(value) {
  return Math.round(value * 10000) / 10000;
}

function patternsForBossLevel(level) {
  const safeLevel = Math.max(1, Math.min(MAX_LEVEL, Math.floor(Number(level) || 1)));
  return Object.freeze([BOSS_PATTERN_TIERS[Math.min(9, Math.floor(safeLevel / 10))]]);
}

function getBossLevelConfig(level) {
  const safeLevel = Math.max(1, Math.min(MAX_LEVEL, Math.floor(Number(level) || 1)));
  const progress = (safeLevel - 1) / 98;
  const animal = getBossAnimal(safeLevel);
  const baseHealth = Math.round(24 + progress * 126);
  const baseCarrotSpeed = round4(150 + progress * 270);
  const baseFireInterval = round4(1.25 - progress * 0.93);
  const baseVolleyCount = 1 + Math.floor(progress * 11);
  const baseMaxCarrots = 40 + Math.floor(progress * 140);
  const baseMoveSpeed = round4(55 + progress * 105);
  return Object.freeze({
    level: safeLevel,
    animalKey: animal.key,
    animalName: animal.name,
    health: Math.round(baseHealth * 1.5),
    timeLimitSeconds: 60,
    playerShotInterval: 0.16,
    playerShotSpeed: 820,
    carrotSpeed: round4(baseCarrotSpeed * 1.5),
    fireInterval: round4(baseFireInterval / 1.5),
    volleyCount: Math.ceil(baseVolleyCount * 1.5),
    maxCarrots: Math.ceil(baseMaxCarrots * 1.5),
    moveSpeed: round4(baseMoveSpeed * 1.5),
    patterns: patternsForBossLevel(safeLevel),
    variant: Object.freeze({
      paletteIndex: (safeLevel - 1) % 11,
      armorIndex: Math.floor((safeLevel - 1) / 11)
    })
  });
}

module.exports = { BOSS_PATTERN_TIERS, getBossLevelConfig, patternsForBossLevel, round4 };
